import React, { useState, useEffect } from "react";
import logo from "../assets/mhe_logo.png";
import "../css/style.css";
import "../css/bootstrap.min.css";
import "../css/scanner.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight } from 'react-bootstrap-icons';

const NavMenu = () => {
    const navigate = useNavigate();
    const bearerToken = localStorage.getItem('bearerToken');

    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const location = useLocation();
    const isOnProductsPage = location.pathname.toLowerCase().includes('/products');

    useEffect(() => {
        getCategories();
        getProducts();
    }, []);

    // Fetch product list
    const getProducts = async () => {
        try {
            const response = await axios.get('/Website/getProducts', {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });

            //console.log("Raw products response:", response.data);

            // Only keep active products
            const activeProducts = (response.data || []).filter(p => p.active === 1);

            //console.log("Filtered active products:", activeProducts);

            setProducts(activeProducts);
        } catch (error) {
            if (!bearerToken) {
                console.error('Error fetching product list: bearerToken is null.');
            } else {
                console.error('Error fetching product list:', error);
            }
        }
    };

    // Fetch categories
    const getCategories = async () => {
        try {
            const response = await axios.get('/Website/GetCategories', {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    // Navigate to product page with sorted products and category state
    const navToPage = (page, category) => {
        console.log('Navigating to:', page);
        const sortedProducts = [...products].sort((a, b) => {
            const aHasNx = a.proD_NAME.toLowerCase().includes("nx") ? 0 : 1;
            const bHasNx = b.proD_NAME.toLowerCase().includes("nx") ? 0 : 1;
            if (aHasNx !== bHasNx) {
                return aHasNx - bHasNx; // "nx" names first
            }
            return a.proD_NAME.localeCompare(b.proD_NAME);
        });

        navigate(page, { state: { cat: categories, products: sortedProducts, selCat: category } });
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light sticky-top p-0" style={{ backgroundColor: 'black' }}>
            <a href="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
                <img src={logo} alt="Logo" style={{ maxWidth: '100px' }} />
            </a>

            <button
                type="button"
                className="navbar-toggler me-4"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
            >
                <i className="bi bi-list" style={{ fontSize: '1.5rem', color: 'white' }}></i>
            </button>

            <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav me-auto p-4 p-lg-0">
                    {!isOnProductsPage && (
                        <div className="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">
                                Products
                            </a>
                            <div className="dropdown-menu fade-up m-0" style={{ paddingBottom: "0px", paddingTop: "0px" }}>
                                {categories.map(cat => (
                                    <a
                                        key={cat.caT_ID}
                                        className="dropdown-item"
                                        onClick={() => navToPage('/Products', cat.caT_ID)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {cat.caT_NAME}
                                    </a>
                                ))}
                                <a className="dropdown-item" onClick={() => navToPage('/Products', 0)} style={{ cursor: 'pointer' }}>
                                    Explore all products <ArrowRight className="arrowStyle" />
                                </a>
                            </div>
                        </div>
                    )}

                    <a href="/about" className="nav-item nav-link text-white">
                        About Us
                    </a>

                </div>
            </div>
        </nav>
    );
};

export default NavMenu;